import settings from "./settings";
import auth from "./auth";
import misc from "./misc";

const rootReducer = { settings, auth, misc };

export default rootReducer;
